export default __webpack_public_path__ + "static/media/bmg-placeholder-card-v2.be8d5c44.jpg";